import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import { useHistory } from 'react-router-dom';
import ChevronLeftSvg from '@src/svgs/fr-chevron-left.svg';
import './styles.scss';

export const BackButton: FC = () => {
  const history = useHistory();

  return (
    <Svg
      className="sourcing-header-back-button"
      onClick={() => {
        history.goBack();
      }}
      src={ChevronLeftSvg}
    />
  );
};
